import backend from "../api";
import { useState } from "react";
import { toast } from "react-toastify";

const Contact = () => {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
    if (!!errors[field])
      setErrors({
        ...errors,
        [field]: null,
      });
  };
  const findFormErrors = () => {
    const { email, message, name } = form;
    const newErrors = {};
    // email errors
    if (!email || email === "") newErrors.email = "this field is required";
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      newErrors.email = "Please use a valid format for email";
    }
    //message errors
    if (!message || message === "")
      newErrors.message = "this field is required";

    //name errors
    if (!name || name === "") newErrors.name = "this field is required";
    return newErrors;
  };
  const submitHandler = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      let val = {
        email: form.email,
        message: form.message,
        name: form.name,
      };

      backend
        .post("/contactus", val)
        .then(({ data: { data, message } }) => {
          setForm({});
          toast.success("Your request has been recieved.");
        })
        .catch((err) => {
          toast.error(
            err.response ? err.response.data.message : "Please try again shortly."
          );
        });
    }
  };

  return (
    <div>
      <section>
        <h3>Contact</h3>
        <div className="row ">
          <div className="col-lg-6">
            <div className="contact-right">
              <ul>
                <li className="mb-4">
                  <div>
                    <img
                      src="/images/phone.png"
                      alt="Generic placeholder image"
                    />
                    <h6>Contact Us</h6>
                  </div>

                  <div className="media-body">
                    <h7> 844 Eksplode</h7>
                  </div>
                </li>
                <li className="mb-4">
                  <div className="contact-icon">
                    <i className="fa fa-map-marker" aria-hidden="true" />
                    <h6>Address</h6>
                  </div>
                  <div className="media-body">
                    <h7>ABC Complex,Near xyz, New York</h7>
                    <h7>USA 123456</h7>
                  </div>
                </li>
                <li className="mb-4">
                  <div className="contact-icon">
                    <img
                      src={`/images/email.png`}
                      alt="Generic placeholder image"
                    />
                    <h6>Address</h6>
                  </div>
                  <div className="media-body">
                    <h7>support@eksplode.com</h7>
                    <h7>contact@eksplode.com</h7>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-6 mx-auto register-page section-a-space">
            <div className="theme-card">
              <form className="theme-form" onSubmit={submitHandler}>
                <div className="box-head">
                  <h3>Send us a message</h3>
                </div>

                <div className="form-row">
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="name"> Name</label>
                      <input
                        type="text"
                        className="form-control mb-0"
                        id="name"
                        name="name"
                        placeholder="Name"
                        onChange={(e) => setField("name", e.target.value)}
                      />
                      <label htmlFor="name" className="error">
                        {errors.name && errors.name}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="email">Email</label>
                      <input
                        type="text"
                        className="form-control mb-0"
                        id="email"
                        name="email"
                        placeholder="Email"
                        onChange={(e) => setField("email", e.target.value)}
                      />
                      <label htmlFor="email" className="error">
                        {errors.email && errors.email}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="message">Message</label>
                      <textarea
                        type="text"
                        className="form-control mb-0"
                        id="message"
                        name="message"
                        placeholder="Message"
                        onChange={(e) => setField("message", e.target.value)}
                      />
                      <label htmlFor="message" className="error">
                        {errors.message && errors.message}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-end"></div>

                <button className="btn btn-danger ml-auto" type="submit">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
